import api from "@/Library/api.js";
import method from "@/Library/method.js";
let apiresult;
let controller;
let action;
let url;

export default {

    /** 获取窝次信息列表 **/
    GET_NEST_LIST(data) {
        controller='Petnest';
        action='GetPetnest';
        url='/'+controller+'/'+action;
        apiresult=method.CheckMenuIsAuth(data,controller,action);
        if(apiresult.error > 0) return apiresult.result;
        return api({ url: url, method: "post", data: data }); 
    },

    /** 删除窝次信息 **/
    DEL_NEST(data) {
        controller='Petnest';
        action='DelPetNest';
        url='/'+controller+'/'+action;
        apiresult=method.CheckMenuIsAuth(data,controller,action);
        if(apiresult.error > 0) return apiresult.result;
        return api({ url: url, method: "post", data: data }); 
    },

    /** 新增窝次信息 **/
    ADD_NEST(data) {
        controller='Petnest';
        action='AddNest';
        url='/'+controller+'/'+action;
        apiresult=method.CheckMenuIsAuth(data,controller,action);
        if(apiresult.error > 0) return apiresult.result;
        return api({ url: url, method: "post", data: data }); 
    },

    /** 编辑窝次信息 **/
    EDIT_NEST(data) {
        controller='Petnest';
        action='EditNest';
        url='/'+controller+'/'+action;
        apiresult=method.CheckMenuIsAuth(data,controller,action);
        if(apiresult.error > 0) return apiresult.result;
        return api({ url: url, method: "post", data: data }); 
    },

    /** 获取窝次信息详情 **/
    GET_NEST_INFOS(data) {
        controller='Petnest';
        action='GetNestInfos';
        url='/'+controller+'/'+action;
        apiresult=method.CheckMenuIsAuth(data,controller,action);
        if(apiresult.error > 0) return apiresult.result;
        return api({ url: url, method: "post", data: data }); 
    }

}